import React from 'react'
import styles from './styles'
import MarketingBanner from 'components/MarketingBanner'

const EmptyList = () => (
  <div className={styles.noResultsContainer}>
    <strong>There aren&apos;t currently candidates that match your filters 😢</strong>
    <p className={styles.content}>
      Every Monday 100+ new developers are added, so there is a good chance we&apos;ll have candidates that you&apos;re looking for soon.
    </p>
    {process.env.NEXT_PUBLIC_ENABLE_GATED_CONTENT_BANNER !== '0' && <MarketingBanner />}
  </div>
)

export default EmptyList
